// Alt indhold på dansk — Morten Junge Bertelsen

export const NAV_LINKS = [
  { label: "Om", href: "#om" },
  { label: "Ekspertise", href: "#ekspertise" },
  { label: "Manifest", href: "#manifest" },
  { label: "Erfaring", href: "#erfaring" },
  { label: "Resultater", href: "#resultater" },
  { label: "Kontakt", href: "#kontakt" },
];

export const CONTACT = {
  email: "mjb783@gmail.com",
  phone: "+45 4111 1040",
  phoneHref: "tel:+4541111040",
  linkedin: "https://www.linkedin.com/in/morten-j-4512b554/",
  location: "Hjortshøj, Aarhus",
};

export const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_shopify-growth-hub-3/artifacts/u0qteeyn_Web_Photo_Editor.jpg";

export const EXPERTISE = [
  {
    id: "01",
    title: "Omnichannel & Unified Commerce",
    body: "Sammenhængende kunderejser på tværs af web, butik og B2B — bygget på ét fælles datagrundlag.",
  },
  {
    id: "02",
    title: "E-commerce platforme & CMS",
    body: "Strategi, valg og drift af platforme som ShopWare og Optimizely — fra relancering til daglig performance.",
  },
  {
    id: "03",
    title: "PIM, ERP, DAM & iPaaS",
    body: "Integrationer der samler produktdata, logistik og medier i skalerbar digital infrastruktur.",
  },
  {
    id: "04",
    title: "Performance Marketing & SEO",
    body: "Struktureret organisk vækst og betalt annoncering med fokus på ROAS og customer lifetime value.",
  },
  {
    id: "05",
    title: "CRM / CDP & Automation",
    body: "Datadrevne kunderejser: welcome-, abandoned basket-, refill- og reaktiveringsflows der konverterer.",
  },
  {
    id: "06",
    title: "Datadrevet ledelse",
    body: "CAC- og LTV-modeller i Power BI som beslutningsgrundlag for både digitale og fysiske salgskanaler.",
  },
  {
    id: "07",
    title: "AI & GenAI i forretningen",
    body: "Automatisering af content- og driftsprocesser med AI — dokumenteret op til 80% hurtigere produktion.",
  },
  {
    id: "08",
    title: "Digital transformation",
    body: "Forandringsledelse og bindeled mellem IT, marketing og forretning i komplekse organisationer.",
  },
];

export const MANIFESTO = [
  {
    id: "01",
    title: "E-commerce er en forretningsdisciplin — ikke en kanal.",
    body: "På direktions- og bestyrelsesniveau måles digital handel ikke i klik, men i indtjening, skalerbarhed og strategisk position. Jeg flytter e-commerce fra en operationel opgave til en strategisk funktion.",
  },
  {
    id: "02",
    title: "Data før mavefornemmelse.",
    body: "Beslutninger skal hvile på tal. Med CAC-, LTV- og retention-modeller skaber jeg transparens i performance på tværs af kanaler — så investeringer kan forsvares og skaleres.",
  },
  {
    id: "03",
    title: "Skalerbarhed bygges i infrastrukturen.",
    body: "Vækst holder kun, hvis fundamentet gør. CMS, PIM, ERP og DAM skal spille sammen, før man skruer op for markedsføringen. Ellers skalerer man kaos.",
  },
  {
    id: "04",
    title: "Teknologi virker først, når mennesker følger med.",
    body: "De største gevinster kommer, når systemer, processer og teams trækker samme vej. Forandringsledelse er lige så afgørende som selve platformen.",
  },
];

export const CAREER = [
  {
    company: "ShopSEO",
    role: "Partner",
    period: "2026 — Nu",
    body: "Partner i ShopSEO sammen med Magnus Løv. Rådgivning og eksekvering inden for e-commerce, SEO og datadrevet digital vækst for brands og vækstvirksomheder.",
    highlight: true,
  },
  {
    company: "Klikko.io",
    role: "Head of Content & Production",
    period: "2025 — 2026",
    body: "Ledede content-produktion og AI-automatisering på tværs af flere platforme. Reducerede produktionstid med op til 80% via n8n og AI-workflows.",
  },
  {
    company: "Stof & Stil / Selfmade",
    role: "Chief Digital Officer (CDO)",
    period: "2022 — 2024",
    body: "Genopbyggede e-commerce som selvstændigt, strategisk forretningsområde. Implementerede nyt CMS (ShopWare) med integration til ERP, PIM og iPaaS, og etablerede datadrevet beslutningsgrundlag med CAC/LTV-modeller i Power BI.",
    highlight: true,
  },
  {
    company: "Ecooking",
    role: "Head of Global E-commerce",
    period: "2020 — 2022",
    body: "Fordoblede omsætningen fra 10 til 24 mio. DKK på ét år. Byggede ny ShopWare-webshop (finalist til E-handelsprisen), etablerede Unified Commerce med POS-integration og avancerede CRM-flows. Medansvarlig i due diligence ved salg til kapitalfond.",
    highlight: true,
  },
  {
    company: "Carl Hansen & Søn",
    role: "International E-commerce Manager",
    period: "2017 — 2020",
    body: "Lancerede international omnichannel-platform (Optimizely) i Danmark, Japan og resten af verden. Øgede online salg med 250% på ét år og email-leadgenerering med over 1.000%.",
    highlight: true,
  },
  {
    company: "Rosemunde Copenhagen",
    role: "E-commerce Manager",
    period: "2015 — 2017",
    body: "Udviklede og eksekverede international webshopstrategi for DK og DE. Øgede online salg med 20% YoY og automatiserede indkøbs- og lagerprocesser.",
  },
  {
    company: "WhiteAway.com",
    role: "Head of Development & Salgsleder",
    period: "2009 — 2012",
    body: "Byggede skalerbar digital infrastruktur for fem webshops og et stærkt salgsteam. Månedlig omsætning steg fra 2 til 12 mio. DKK.",
  },
];

export const RESULTS = [
  { value: "10 → 24", unit: "mio. DKK", label: "Ecooking — omsætning fordoblet på ét år" },
  { value: "+250%", unit: "online salg", label: "Carl Hansen & Søn — på ét år" },
  { value: "+1.000%", unit: "email-leads", label: "Carl Hansen & Søn — leadgenerering" },
  { value: "2 → 12", unit: "mio. DKK", label: "WhiteAway — månedlig omsætning" },
  { value: "Nr. 4", unit: "E-handelsprisen", label: "Finalist 2021 — Dansk Erhverv" },
  { value: "−80%", unit: "produktionstid", label: "Klikko — content via AI-automatisering" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Jeg kan kun give Morten mine varmeste anbefalinger. Han har en stærk kombination af datadrevet skarphed og menneskelig indsigt — ekstremt dygtig til tal, analyser og systemer, og kvaliteten af hans arbejde er konsekvent høj. Samtidig er han en utrolig behagelig kollega, der møder andre med tålmodighed og empati. Enhver organisation vil være heldig at få Morten med ombord.",
    name: "Johanna Krüger Holmen",
    title: "People & Performance Lead",
    relation: "Arbejdede sammen med Morten",
  },
  {
    quote:
      "Morten er en fantastisk manager, der kombinerer et performance-mindset med empati, støtte og faglig udvikling. Han skaber struktur og en resultatorienteret retning — en type, der ofte siger “Lad os teste det!” og “Show me the numbers!”. Han skaber en kultur præget af tryghed og tillid, og en følelse af at have en leder, der virkelig har ens ryg. Jeg kan på det varmeste anbefale Morten.",
    name: "Arian Khameneh",
    title: "Marketing Lead",
    relation: "Rapporterede direkte til Morten",
  },
  {
    quote:
      "Jeg har haft fornøjelsen af at arbejde tæt sammen med Morten gennem en længere periode. En rigtig jysk leder — begge ben solidt plantet i jorden. Rolig, lyttende og åben for andres ekspertise. Var der uenighed om retningen, var svaret altid “det må vi teste”. Morten har styr på data og lader folk udfolde deres ekspertise. Jeg vil til hver en tid anbefale ham som en god leder.",
    name: "Niklas Wingsted",
    title: "Content & Ads for SMV’er",
    relation: "Rapporterede direkte til Morten",
  },
  {
    quote:
      "Jeg har arbejdet tæt med Morten på udvikling af et større e-commerce projekt. Han fungerede godt i rollen som product owner og reagerede altid hurtigt og løsningsorienteret. Diskussionerne bar præg af en stærk e-commerce forståelse og velbegrundede argumenter. Det har været en fornøjelse at mærke hans passion for det digitale.",
    name: "Christian Lindhardt Andersen",
    title: "Partner · Composable Commerce",
    relation: "Kunde hos Morten",
  },
];

export const AWARDS = [
  "Finalist — Dansk Erhvervs E-handelspris (B2C under 100 mio.)",
  "Mini-MBA i kunstig intelligens / AI",
  "Ecooking solgt til kapitalfond (2021)",
  "Globalt PIM & CMS hos Carl Hansen & Søn",
];
